import React from 'react';
import PropTypes from 'prop-types';
import Immutable from 'seamless-immutable';
import cloneDeep from 'lodash.clonedeep';
import {generateRoutePath, processPathname, getPath} from 'epic-common/src/route';
import {LoginActions} from '../../actions';
import EpicGamesNav from 'epic-games-nav/app/scripts/EpicGamesNav';
import {processParams} from 'epic-common/src/url';

class EpicGamesNavWrapper extends React.Component {
    static propTypes = {
        history: PropTypes.object,
        location: PropTypes.object,
        localizationStore: PropTypes.object,
        headerStore: PropTypes.object,
        loadingSection: PropTypes.number,
        appConfigStore: PropTypes.object,
        modsEnabled: PropTypes.bool,
        mobile: PropTypes.bool,
        tablet: PropTypes.bool
    };

    /**
     * Checks the CMS 'useCustomCallback' and assigns an onClick pointing to the link's href
     * @param {Object} link
     */
    addOnClick(link, history) {
        if (link && link.useCustomCallback && link.href) {
            link.onClick = (e) => {
                if (process.env.NODE_ENV !== 'production') {
                    console.debug(`EGHWrapper.onClick() ${link.href}`);
                }
                if (processPathname(getPath()).indexOf('/home') === -1 || link.key === 'news') {
                    e.preventDefault();
                    e.stopPropagation();
                    history.push(generateRoutePath(link.href));
                    if (link.key === 'logo') {
                        if ($.fn.fullpage && typeof $.fn.fullpage.moveTo === 'function') {
                            $.fn.fullpage.moveTo(1);
                        }
                    }
                }
            };
        }
        return Immutable(link);
    }

    setLinks(links) {
        const {history} = this.props;
        links.forEach((link) => {
            this.addOnClick(link, history);

            const linkPath = generateRoutePath(link.href);
            let hash = '';
            if (link.href.indexOf('#') > -1) {
                [, hash] = link.href.split('#');
            }
            if (this.props.location.pathname.indexOf(linkPath) > -1) {
                link.active = true;
            } else if (hash && this.props.location.hash.indexOf(hash) > -1) {
                link.active = true;
            } else {
                link.active = false;
            }
        });

        return Immutable(links);
    }

    getSignInSearch() {
        const {messages} = this.props.localizationStore;
        const regMsg = messages['epic.odin.accountportal.default.register'];
        const loginMsg = messages['epic.odin.accountportal.default.sign_in'];
        const loginParams = {
            regSubheading: regMsg,
            loginSubheading: loginMsg,
            state: this.props.location.pathname || '/'
        };
        return `?${processParams(loginParams)}`;
    }

    setSignInLinks(signInLinks) {
        const links = [];
        const {messages} = this.props.localizationStore;
        signInLinks.forEach((signInLink) => {
            if (signInLink) {
                if (signInLink.key === 'epic-sign-in') {
                    signInLink.title = messages['epic.odin.common.signin_epic'];

                    signInLink.href += this.getSignInSearch();
                    links.push(signInLink);
                }
            }
        });
        return links;
    }

    /**
     * Set each account link details and click handlers
     * @param {Object} accountLinks
     */
    setAccountLinks(accountLinks) {
        const al = cloneDeep(accountLinks || {});

        if (al.signOutLink) {
            al.signOutLink.onClick = (e) => {
                LoginActions.handleLogout();
            };
        }

        if (al.signInLinks) {
            const signInLinks = al.signInLinks.asMutable ? al.signInLinks.asMutable() : al.signInLinks || [];
            al.signInLinks = this.setSignInLinks(signInLinks);
        }

        if (al.dropdownLinks) {
            const dropdownLinks = [];
            al.dropdownLinks.forEach((dropdownLink) => {
                if (dropdownLink) {
                    dropdownLinks.push(dropdownLink);
                }
            });

            al.dropdownLinks = dropdownLinks;
        }

        return Immutable(al);
    }

    /**
     * Prepares an Immutable array of locale options for the header.
     * @returns [{ name: 'English', lang: 'en-US'}]
     */
    setLocale() {
        return Immutable(this.props.localizationStore.supportedLocales);
    }

    render() {
        const config = this.props.headerStore.config ? this.props.headerStore.config.asMutable({deep: true}) : {};
        if (!config) return (<div />);
        const modsEnabled = this.props.modsEnabled || false;
        const links = this.setLinks(config.links || []);
        const displayName = '';
        const accountLinks = this.setAccountLinks(config.accountLinks || {});
        const localeOptions = this.setLocale();
        const {locale} = this.props.localizationStore;
        const logoLink = this.addOnClick(config.logoLink || {}, this.props.history);
        const {
            callToAction,
            downloadLink,
            messages,
            macDownloadUrl,
            pcDownloadUrl,
            alert
        } = config;
        const properties = Immutable(config.properties);
        return (
            <div>
                <EpicGamesNav
                    epicPropertyName={config.epicPropertyName || ''}
                    epicPropertyClasses={this.props.loadingSection > 1 ? 'transparent' : ''}
                    hideSearch={config.hideSearch}
                    hideSignIn={config.hideSignIn}
                    hideLocale={config.hideLocale}
                    hideCallToAction={this.props.mobile || this.props.tablet ? true : !modsEnabled}
                    hideShieldDownload={modsEnabled ? config.hideShieldDownload : true}
                    displayName={displayName}
                    logoLink={logoLink}
                    links={links}
                    localeOptions={localeOptions}
                    locale={locale}
                    accountLinks={accountLinks}
                    euCookie={this.props.appConfigStore.euCookieMessage}
                    isEu={this.props.appConfigStore.isEu}
                    callToAction={callToAction}
                    downloadLink={downloadLink}
                    messages={messages}
                    macDownloadUrl={macDownloadUrl}
                    pcDownloadUrl={pcDownloadUrl}
                    alert={alert}
                    properties={properties} />
            </div>
        );
    }
}

export default EpicGamesNavWrapper;
